export const darkTheme = {
    bg:"#15171E",
    bgLighter:"#1C1E27",
    itemHover: "#3A3C45",
    itemText:"#DADEDF",
    primary: "#854CE6",
    bgDark:"#15171E",
    text:"#F2F3F4",
    textSoft:"#C1C7C9",
    soft:"#373D3F",
    soft2:"#8C979A",
    card: "#1C1E27",
    lightAdd:"99",
    yellow: "#fccf03",
    green: "#03fc45",
    pink: "#fc036b",
    recieve_message: "#1a1826",
    chat_background: "#100f17",
    send_message: "#4f34ad",
    contact_background: "#151a21",

    /*Colors
Swatch 1
#030405
Swatch 2
#585759
Swatch 3
#03840c
Swatch 4
#acb0b3
Swatch 5
#185c1a
Swatch 6
#40b957*/
}

export const lightTheme = {
    bg:"#F8F9FD",
    bgLighter:"#FFFFFF",
    itemHover: "#F7F5F4",
    itemText:"#555F61",
    primary: "#854CE6",
    bgDark:"white",
    text:"#2F2F2F",
    textSoft:"#606060",
    soft:"#C4C4C4",
    soft2:"#757575",
    card: "#FFFFFF",
    lightAdd:"",
    recieve_message: "#ffffff",
    chat_background: "#f5f5fc",
    send_message: "#4f34ad",
    send_message_text_color: "#ffffff",
    contact_background: "#ffffff",

  }